import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { requireAppCheck } from '@jfw/angular/shared/app-check';
import { PLATFORM_DP_ENVIRONMENT } from '@jfw/angular/shared/tokens';
import { PackingSlipRow } from '@jfw/types';
import { catchError, map, Observable, of } from 'rxjs';

type PackingSlipsResult = {
  success: boolean;
  data: PackingSlipRow[];
};

@Injectable({
  providedIn: 'root',
})
export class WholesalePackingSlipsService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(PLATFORM_DP_ENVIRONMENT);
  private readonly apiUrl = this.environment.delivery_api_server_url;

  public getPackingSlips(accountNumber: string): Observable<PackingSlipsResult> {
    return this.http
      .get<PackingSlipRow[]>(`${this.apiUrl}/packing-slips/${accountNumber}`, {
        ...requireAppCheck,
      })
      .pipe(
        map((data) => ({
          success: true,
          data,
        })),
        catchError((error) => {
          console.error(error);
          return of({ success: false, data: [] });
        }),
      );
  }
}
